<script setup lang="ts">
import Button from '@ui/components/button/Button.vue'
import Divider from '@ui/components/divider/Divider.vue'
import { ButtonVariant, Sizes } from '@ui/styles'

withDefaults(
  defineProps<{
    valid?: boolean
    changed?: boolean
  }>(),
  {
    valid: false,
    changed: false,
  },
)

defineEmits(['reset', 'confirm'])
</script>

<template lang="pug">
.actions.flex.col-20.p-t-8.m-t-auto
  Divider(variant="base")
  .flex.row-16
    Button.flex-1(label="general.reset" :disabled="!changed" :variant="ButtonVariant.Secondary" :size="Sizes.Leia" @click="$emit('reset')")
    Button.flex-1(label="general.select" :disabled="!changed || !valid" :size="Sizes.Leia" @click="$emit('confirm')")
</template>
